export const getSafe = (fn: Function, defaultValue = null) => {
  try {
    let value = fn()
    if (value === null || value === undefined) return defaultValue
    else return value
  } catch (e) {
    return defaultValue
  }
}

const TAG_PALETTE = [
  '#e74c3c', // red
  '#e67e22', // orange
  '#f1c40f', // yellow
  '#2ecc71', // green
  '#1abc9c', // teal
  '#3498db', // blue
  '#9b59b6', // purple
  '#e84393', // pink
  '#00b894', // mint
  '#6c5ce7', // indigo
  '#fd79a8', // rose
  '#00cec9', // cyan
  '#a29bfe', // lavender
  '#fab1a0', // salmon
  '#55efc4', // aqua
  '#74b9ff', // sky
]

export const stringToColor = (str: string) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return TAG_PALETTE[Math.abs(hash) % TAG_PALETTE.length]
}